import { useHead } from '@unhead/react';

import { RepairForm } from './components/status-form';
import { useCreateRepair } from './hooks/use-create-repair';
import { useTranslation } from 'translations/hooks';
import { ContentHeader } from 'ui/components/content-header';
import { ImagePointer } from 'business/receipt/components/image-pointer';

import segmentDrawDown from 'ui/segment/down.png';
import segmentDrawUp from 'ui/segment/up.png';
import { QuarantineDefectOrientationEnum } from 'business/receipt/pages/choose-segment-status/types';
import { Descriptions } from 'antd';

export const ReceiptRepairPage = () => {
  const { t } = useTranslation();

  const {
    form,
    serialNumber,
    segmentType,
    quarantineDefect,
    defectRepairTypes,
    handleSubmit,
    isLoading,
  } = useCreateRepair();

  useHead({
    title: t('receipt.repair.title'),
  });

  const items = [
    {
      key: 'serialNumber',
      label: t('chooseSegmentStatus.details.serialNumber'),
      children: serialNumber,
    },
    {
      key: 'segmentType',
      label: t('chooseSegmentStatus.details.segmentType'),
      children: segmentType ?? '-',
    },
    {
      key: 'manufactureDate',
      label: t('chooseSegmentStatus.form.quarantine.type'),
      children: quarantineDefect?.type ?? '-',
    },
  ];

  return (
    <ContentHeader title={t('chooseSegmentStatus.title')}>
      <div className="flex w-full gap-14 bg-white p-4">
        <div className="flex items-center">
          <ImagePointer
            position={{
              x: quarantineDefect?.positionX ?? 0,
              y: quarantineDefect?.positionY ?? 0,
            }}
            image={
              quarantineDefect?.localization ===
              QuarantineDefectOrientationEnum.Up
                ? segmentDrawUp
                : segmentDrawDown
            }
          />
        </div>
        <Descriptions
          items={items}
          colon={false}
          layout="vertical"
          column={2}
        />
      </div>

      <RepairForm
        form={form}
        save={handleSubmit}
        defectRepairTypes={defectRepairTypes}
        isFetching={isLoading}
      />
    </ContentHeader>
  );
};
